/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { NavigateRoutes, Buttons } from '../../../constant';
import SwapCourseLocation from '../../admin-user/swap-course-location';
import { DialogAtom } from '../../../components/atoms';
import { getCurrentYear, getFormattedDate, isValidSemesterYear } from '../../../utils/methods';
import styles from './style';
import useStyles from '../../../custom-hooks/useStyles';
import Loader from '../../../components/atoms/loader';
import DataGridProTable from '../../../components/atoms/data-grid-pro-students';
import { Student, SwapCourse } from './helper';
import StudentHeader from './header';
import ButtonAtom from '../../../components/atoms/button';
import { SwapCourseDialogFooter } from '../../admin-user/students/helper';
import { getAllLocationCourse } from '../../../store/actions/getLocationCoordinator';
import useLocationCoordinator from '../../../custom-hooks/useLocationCoordinator';
import { getQuarterColumnsData, getSemesterColumnsData } from './columns';
import { getGrades } from '../../../store/actions/getGrades';

export default function StudentList({
  setDialogOpen,
  setLoading,
  refreshList,
  loading,
  visibleFields,
  fileHeaders,
  setCourseData,
  courseData,
  setOpenDialog,
  validSemester,
  setValidSemester,
  setOpenDialogPermissionsError,
  setDialogErrorImportMessage,
  setAcadYear
}) {
  const classes = useStyles(styles)();
  const { t } = useTranslation();
  const [selectedRows, setSelectedRows] = React.useState([]);
  const validationSchema = Yup.object({});
  const coordinatorInfo = useLocationCoordinator();
  const students = coordinatorInfo?.students;
  const assignedLocations = coordinatorInfo?.assignedLocations;
  const assignedYears = coordinatorInfo?.assignedYears;
  const [rowData, setRowData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [gridLoading, setGridLoading] = useState(true);
  const [locations, setLocationData] = useState([]);
  const [years, setYearsData] = useState([]);
  const [fileName, setFileName] = useState(false);
  const [error, setError] = useState('');
  const [customForm, setCustomForm] = useState('');
  const [isSwapCourseDialog, setSwapCourseOrLocation] = useState(false);
  const [selectedLocationForCourse, setSelectedLocationForCourse] = useState([]);
  const [pageSize, setPageSize] = React.useState(25);
  const locationCoordinatorData = useSelector((state) => state?.getLocationCoordinator);
  const selectedYearRedux = locationCoordinatorData?.selectedYear;
  const selectedLocationRedux = locationCoordinatorData?.selectedLocations;
  const selectedCourseRedux = locationCoordinatorData?.selectedCourse;
  const [swapCourseLocationInfo, setCourseLocationInfo] = useState({
    studentId: '',
    studentName: '',
    acedemicYear: '',
    courseFrom: '',
    courseTo: '',
    locationFrom: '',
    locationTo: '',
    sectionFrom: '',
    sectionTo: '',
    changeLogs: '',
  });
  const [disableMovestudent, setDisableMovestudent] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const gradesData = useSelector((state) => state.getGrade);

  useEffect(() => {
    dispatch(getGrades(setOpenDialogPermissionsError, setDialogErrorImportMessage));
  }, []);

  const formik = useFormik({
    initialValues: {
      academicYear: years?.[0]?.id,
      locationId: locations?.[0]?.id,
      courseId: courseData?.[0]?.id,
    },
    validationSchema,
    onSubmit: () => {
      setLoading(true);
    },
  });

  useEffect(() => {
    setStudentData(students);
  }, [students]);

  useEffect(() => {
    return () => {
      setStudentData([]);
      setRowData([]);
    };
  }, []);

  useEffect(() => {
    setLocationData(assignedLocations);
    setYearsData(assignedYears);
    if (selectedLocationRedux?.value) {
      formik.setFieldValue('locationId', selectedLocationRedux?.value);
    } else {
      formik.setFieldValue('locationId', assignedLocations?.[0]?.id);
    }

    const currentYear = getCurrentYear()?.id;
    const selectedYear = assignedYears?.filter((opt) => opt?.id === currentYear.toString());
    if (selectedYearRedux?.id) {
      formik.setFieldValue('academicYear', selectedYearRedux?.id);
    } else {
      formik.setFieldValue('academicYear', selectedYear?.[0]?.id);
    }
  }, [assignedLocations, assignedYears]);

  useEffect(() => {
    let payload = {};
    if (selectedLocationRedux?.value) {
      const locationId = selectedLocationRedux?.value;
      payload = {
        ...payload,
        locationId,
      };
    } else {
      if (selectedLocationForCourse.length === 0) {
        const locationId = assignedLocations[0]?.id;
        payload = {
          ...payload,
          locationId,
        };
      } else {
        const locationId = selectedLocationForCourse;
        payload = {
          ...payload,
          locationId,
        };
      }
    }
    dispatch(getAllLocationCourse(payload));
  }, [selectedLocationForCourse, assignedLocations]);

  useEffect(() => {
    setCourseData(locationCoordinatorData?.locationCourses);
  }, [locationCoordinatorData?.locationCourses]);

  useEffect(() => {
    setError('');
    if (assignedLocations?.length === 0 || formik?.values?.courseId?.length === 0) {
      setGridLoading(false);
      setLoading(false);
      setStudentData([]);
    } else {
      setGridLoading(true);
      setSelectedRows([]);
    }
    const locData = assignedLocations?.filter(
      (i) => i?.id === formik.values.locationId,
    );
    const date = getFormattedDate(new Date());
    const file = `Students - ${locData[0]?.name}-${formik.values.academicYear}-${date}`;
    setFileName(file);
    setValidSemester(isValidSemesterYear(formik?.values?.academicYear));
    setAcadYear(formik?.values?.academicYear);
    const payload = {
      locationId: formik?.values?.locationId,
      academicYear: formik?.values?.academicYear,
      courseId: formik?.values?.courseId,
    };
    if (payload?.locationId && payload?.academicYear && payload?.courseId && formik?.values?.courseId?.[0] !== undefined) {
      refreshList(payload);
    }
  }, [
    formik?.values?.locationId,
    formik?.values?.academicYear,
    formik?.values?.courseId,
  ]);

  useEffect(() => {
    const data = new Student(studentData);
    setRowData(data);
    if (assignedLocations?.length) {
      setGridLoading(loading);
    }
  }, [studentData]);

  const viewLogs = (onClose) => {
    onClose(false);
    navigate(NavigateRoutes.STUDENTS_LOGS);
  };

  const handleMoveStudent = () => {
    customForm.handleSubmit();
  };

  const refreshStudentData = () => {
    setLoading(true);
    const payload = {
      locationId: formik?.values?.locationId,
      academicYear: formik?.values?.academicYear,
      courseId: formik?.values?.courseId,
    };
    refreshList(payload);
  };

  const swapCourseDialogFooter = (
    <SwapCourseDialogFooter
      classes={classes}
      t={t}
      primaryHandle={handleMoveStudent}
      secHandle={() => setSwapCourseOrLocation(false)}
      viewLogs={viewLogs}
      disableMovestudent={disableMovestudent}
    />
  );
  const isChangeLogVisible = false;
  const swapCourseLocation = (
    <SwapCourseLocation
      refreshStudentsData={refreshStudentData}
      {...{
        setCourseLocationInfo,
        swapCourseLocationInfo,
        setCustomForm,
        setSwapCourseOrLocation,
        courseData,
        isChangeLogVisible,
        setDisableMovestudent,
        isSectionChanged: true,
      }}
    />
  );

  const [columns, setColumns] = useState();
  const [exportSuccesfull, setExportSuccessfull] = useState(false);
  
  const handleExportOk = () => {
    setExportSuccessfull(false);
  };
  const renderExportSuccessfull = () => (
    <Grid className={classes.studentBox}>
      <Box
        component="form"
        sx={{
          '& .MuiTextField-root': { m: 1, width: '25ch' },
        }}
        noValidate
        autoComplete="off"
      >
        <Grid>
          <div className={classes.alertprimary} role="alert">
            {t('STUDENT_CSV_EXPORTED_SUCCESSFULLY_NEW')}
          </div>
        </Grid>
      </Box>
      <Grid item xs={12} className={`${classes.dialogButtons} ${classes.popupButton}`}>
        <ButtonAtom
          className={classes.popupBtn}
          name={t('OK')}
          onClick={handleExportOk}
          btntype={Buttons.PRIMARY}
        />
      </Grid>
    </Grid>
  );
  useEffect(() => {
    if (validSemester) {
      const columnsData = getSemesterColumnsData(
        visibleFields,
        t,
        classes,
        setOpenDialog,
        SwapCourse,
        dispatch,
        navigate,
        setCourseLocationInfo,
        setSwapCourseOrLocation,
        gradesData,
        formik?.values?.academicYear
      );
      setColumns(columnsData);
    } else {
      const columnsData = getQuarterColumnsData(visibleFields, t, classes, setOpenDialog, SwapCourse, dispatch, navigate, setCourseLocationInfo, setSwapCourseOrLocation);
      setColumns(columnsData);
    }
  }, [visibleFields, validSemester, gradesData, formik?.values?.academicYear]);
  const showDetail = () => {
    if (gridLoading || loading) {
      return (
        <Grid>
          <Loader message={t('LOADING')} />
        </Grid>
      );
    }
    if (studentData?.length > 0) {
      return (
        <Grid xs={12} md={12} mt={5} className={classes.studentsList}>
          <DataGridProTable
            data={rowData}
            columns={columns}
            autoHeight
            hideFooter={false}
            disableColumnFilter
            disableColumnSelector
            checkboxSelection
            disableColumnMenu
            disableColumnResize
            disableSelectionOnClick
            ColumnUnsorted
            ColumnSortedAscending
            ColumnSortedDescending
            onSelectionModelChange={(ids) => {
              setError('');
              const selectedIDs = new Set(ids);
              const selectedData = rowData.filter((row) => selectedIDs.has(row.id));
              setSelectedRows(selectedData);
            }}
            loading={gridLoading}
            pageSize={pageSize}
            pagination={true}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[25, 50, 75, 100]}
          />
        </Grid>
      );
    }
    if (studentData?.length === 0 || assignedLocations?.length === 0 || formik?.values?.courseId?.length === 0) {
      return (
        <Grid container style={{ textAlign: 'center', height: '5vw', marginTop: '7vw' }} className={classes.noData}>
          <Grid item xs={12} justifyContent="center">
            <DoNotDisturbIcon />
          </Grid>
          <Grid item xs={12} justifyContent="center">
            <Typography variant="subtitle2" color="text.secondary">
              {t('NO_DATA')}
            </Typography>

          </Grid>
        </Grid>
      );
    }

    return null;
  };
  return (
    <Grid container>
      <Grid xs={12}>
        <StudentHeader
          {...{
            setSelectedRows,
            setExportSuccessfull,
            formik,
            locations,
            years,
            courseData,
            t,
            rowData,
            fileHeaders,
            fileName,
            setDialogOpen,
            selectedRows,
            setError,
            selectedCourseRedux,
            setSelectedLocationForCourse,
            setLoading,
            gradesData
          }}
        />
      </Grid>
      <Grid container spacing={2} direction="row" display="flex" alignItems="center">
        <span className={classes.errorText}>{error}</span>
      </Grid>

      {showDetail()}

      <DialogAtom
        secHandle={() => setSwapCourseOrLocation(false)}
        isOpen={isSwapCourseDialog}
        dialogHeading={t('SWAP_SECTION')}
        customClass={classes.swapCourseDialog}
        footer={swapCourseDialogFooter}
        content={swapCourseLocation}
      />
      <DialogAtom
              isOpen={exportSuccesfull}
              dialogHeading={t('STUDENT_EXPORT')}
              customClass={classes.DialogAtom}
              content={renderExportSuccessfull()}
              secHandle={() => handleExportOk()}
            />
    </Grid>
  );
}
